import { Button, Grid, Typography } from "@mui/material"

export type StartModeProps = {
  onBuildClick: () => void
}

const StartMode = (props: StartModeProps) => {
  return (
    <Grid
      container
      direction="column"
      gap={5}
      alignContent="center"
      justifyContent="center"
      justifyItems="center"
      sx={{ height: "100%" }}
    >
      <Grid item alignSelf="center">
        <Button variant="contained" color="error" onClick={() => props.onBuildClick()}>
          Build new graph
        </Button>
      </Grid>

      <Grid item>
        <Typography>Or choose existing graph on the sidebar</Typography>
      </Grid>
    </Grid>
  )
}

export default StartMode
